import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { IPageInfo } from '../../core/interfaces/interface';
import { SEOService } from '../../core/services/seo.service';
import { GetDataService } from '../shared/services/get-data.service';

@Component({
  selector: 'app-landing-layout',
  imports: [RouterModule, InlineSVGModule],
  templateUrl: './landing-layout.component.html',
  styleUrl: './landing-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingLayoutComponent {
  targetSEOKey = undefined;
  constructor(
    private activatedRoute: ActivatedRoute,
    private seo: SEOService,
    private getDataService: GetDataService,
  ) { }

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ pageInfoSEOKey }) => {
      this.targetSEOKey = pageInfoSEOKey;
      this.loadSEO(pageInfoSEOKey);
    });
  }
  async loadSEO(seoKey: string) {
    if (!seoKey)
      return
    var res = (await this.getDataService.getSEOMetaData(seoKey)) as any;
    if (seoKey == this.targetSEOKey && res) {
      this.seo.setPageSEO(res);
    }
  }
}
